import getGlobalObject from './getGlobalObject';
export default () => getGlobalObject().location.port;
